import { render } from "./DiscoveryVideoModal.vue?vue&type=template&id=211eac41&scoped=true"
import script from "./DiscoveryVideoModal.vue?vue&type=script&lang=js"
export * from "./DiscoveryVideoModal.vue?vue&type=script&lang=js"

import "./DiscoveryVideoModal.vue?vue&type=style&index=0&id=211eac41&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-211eac41"]])

export default __exports__